import { call, put, takeEvery, takeLatest, delay } from "redux-saga/effects"
import { CREATE_INCOME_RANGE, UPDATE_INCOME_RANGE } from "./Constants";
import { createIncomeRangeAPI, updateIncomeRangeAPI } from "./api";
import { createIncomeRangeFail, createIncomeRangeSuccess, updateIncomeRangeFail, updateIncomeRangeSuccess } from "./Actions";

function* createIncomeRangeAsync(payload) {
    try {
        const response = yield call(createIncomeRangeAPI, payload.payload)
        if (response && response.data.status === 1) {
            yield put(createIncomeRangeSuccess(response.data.message))
        } else {
            throw response;
        }

    } catch (error) {
        console.log("error", error)
        yield put(createIncomeRangeFail(error.response.data.error || "Unable to Create Income Range"))
    }
}


function* updateIncomeRangeAsync(payload) {
    try {
        const response = yield call(updateIncomeRangeAPI, payload.payload)
        if (response && response.data.status === 1) {
            yield put(updateIncomeRangeSuccess(response.data.message))
        } else {
            throw response;
        }

    } catch (error) {
        console.log("error", error)
        yield put(updateIncomeRangeFail(error.response.data.error || "Unable to Create Income Range"))
    }
}


function* ManageIncomeSaga() {
    yield takeEvery(CREATE_INCOME_RANGE, createIncomeRangeAsync)
    yield takeEvery(UPDATE_INCOME_RANGE, updateIncomeRangeAsync)
    
    //yield takeLatest(LOGOUT_SU_USER, logoutUser)

}

export default ManageIncomeSaga;